document.addEventListener('DOMContentLoaded', function(){

    const contactForm = document.getElementById('contactForm');
    const responseWrapper = document.getElementById('contactFormResponse');

    contactForm.addEventListener('submit', async function(e){
        e.preventDefault();

        // hide possible previous alert
        responseWrapper.classList.add('d-none');

        // disable submit button
        const submitButton = contactForm.querySelector('button[type="submit"]');
        submitButton.setAttribute('disabled', true);

        // parse form data
        const data = new FormData(contactForm);

        try {
            // send
            const res = await fetch(
                '/api/cs/contactform/add',
                {
                    method: 'POST',
                    body: data,
                },
            );
        
            const resData = await res.json();
        
            if ( resData?.result !== 'success' )
            {
                // error
                if ( resData?.message ) {
                    showResponse(resData.message, true);
                }
                else
                {
                    showResponse('Něco se nepovedlo, zkuste to prosím později.', true);
                }
            }
            else
            {
                // success
                if ( resData?.message ) {
                    showResponse(resData.message);
                }
                else
                {
                    showResponse('Formulář byl odeslán. Děkujeme.');
                }
            }
        } 
        catch (err) {
            // internal error
            showResponse('Něco se nepovedlo, zkuste to prosím později.', true);
        }
        finally {
            // remove disabled on submit
            submitButton.removeAttribute('disabled');

            // reset form
            contactForm.reset();
        }

    });

    function showResponse(text, isError = false){
        const alert = responseWrapper.querySelector('.alert');

        // clear alert of previous attempts
        alert.classList.remove('alert-secondary');
        alert.classList.remove('alert-tertiary');
        alert.innerText = '';

        // set class according to type of response
        let typeClass = 'alert-secondary';

        if ( isError ) {
            typeClass = 'alert-tertiary';
        }

        alert.classList.add(typeClass);

        // set new text
        alert.innerText = text;

        // show alert
        responseWrapper.classList.remove('d-none');

        // scroll to alert
        window.scrollTo({
            top: responseWrapper.getBoundingClientRect().top + window.scrollY - (document.querySelector('#main-header').getBoundingClientRect().height), 
            behavior: 'smooth'
        });
    }

});